import { useStyles } from "./Shop.style";
import {
  GemNumber,
  Header,
  Icon,
  Typography,
  TypographyVariant,
} from "@onmo/ui";
import { TabsList } from "../../components/core/TabsList";
import { useState } from "react";
import ShopAllInventory from "../../components/common/ShopAllInventory/ShopAllInventory";
import ShopOwnedInventory from "../../components/common/ShopOwnedInventory/ShopOwnedInventory";
import ShopAvatarsInventory from "../../components/common/ShopAvatarsInventory/ShopAvatarsInventory";
import ShopBundleInventory from "../../components/common/ShopBundleInventory/ShopBundleInventory";
import ShopBundleDetail from "../../components/common/ShopBundleDetail/ShopBundleDetail";
import InventoryPurchasePopup from "../../components/common/InventoryPurchasePopup/InventoryPurchasePopup";
import PurchaseSuccessPopup from "../../components/common/PurchaseSuccessPopup/PurchaseSuccessPopup";
import { useAppDispatch, useAppSelector } from "../../hooks";
import { setOpenBundle } from "../../slices/shop";
import OurOfGems from "../../components/common/OutOfGems/OutOfGems";
import {
  useFetchBundlesInventory,
  useFetchCoinWallet,
  useFetchOwnedInventory,
} from "../../hooks/resolvers/useShopQuery";
import { InventoriesEmpty } from "../../components/common/InventoriesEmpty";
import Avatar from "../../components/core/Avatar/Avatar";
import { useQuery } from "@apollo/client";
import { meGQL } from "@onmo/graphql/graphql";
import { useCustomNavigate } from "@onmo/ui";
import { useTranslation } from "react-i18next";

const Shop: React.FC = () => {
  const classes = useStyles();
  const { t } = useTranslation();
  const { handleBack } = useCustomNavigate();
  const dispatch = useAppDispatch();
  const [activeTab, setActiveTab] = useState<string>("All");
  const { openBundle } = useAppSelector((state) => state.shop);
  const { data: dataMe } = useQuery(meGQL);
  const { spendableGems } = useFetchCoinWallet();
  const { bundlesInventoryAvailable, bundlesInventoryOwned } =
    useFetchBundlesInventory();
  const { ownedInventory } = useFetchOwnedInventory();

  const onClickBack = () => {
    if (openBundle) {
      dispatch(setOpenBundle({ openBundle: undefined }));
    } else {
      handleBack();
    }
  };

  const renderContent = () => {
    switch (activeTab) {
      case "Owned":
        return bundlesInventoryOwned?.length === 0 &&
          ownedInventory?.length === 0 ? (
          <InventoriesEmpty
            type="Owned"
            onGoToShop={() => setActiveTab("All")}
          />
        ) : (
          <ShopOwnedInventory />
        );
      case "Bundles":
        return bundlesInventoryAvailable?.length === 0 ? (
          <InventoriesEmpty type="Bundles" />
        ) : (
          <ShopBundleInventory />
        );
      case "Avatars":
        return bundlesInventoryAvailable?.length === 0 ? (
          <InventoriesEmpty type="Avatars" />
        ) : (
          <ShopAvatarsInventory />
        );
      default:
        return <ShopAllInventory setActiveTab={setActiveTab} />;
    }
  };

  return (
    <div className={classes.root}>
      <Header
        title={<Avatar url={dataMe?.me?.avatar} />}
        leftElement={
          <Icon name="icon-bold-arrow-left-3" onClick={onClickBack} />
        }
        rightElement={
          <div>
            <Typography variant={TypographyVariant.BodyB6Regular}>
              {t("balance")}
            </Typography>
            <GemNumber
              variant={TypographyVariant.BodyB4Bold}
              amount={spendableGems}
              gemSize={16}
            />
          </div>
        }
      />
      <div className={classes.backdrop} />
      <InventoryPurchasePopup />
      <PurchaseSuccessPopup />
      <OurOfGems />
      {openBundle ? (
        <ShopBundleDetail />
      ) : (
        <div className={classes.content}>
          <TabsList
            listTabs={["All", "Owned", "Bundles", "Avatars"]}
            onChangeTab={setActiveTab}
            activeTab={activeTab}
            className={classes.tabsList}
          />
          {renderContent()}
        </div>
      )}
    </div>
  );
};
export default Shop;
